import type { PdfSceneV1, TubeSceneProduct } from './types.ts';

const MATERIAL_FILE_TOKENS = {
  'photo-paper': 'papel-fotografico',
  'matte-canvas': 'lona-mate',
  'glossy-canvas': 'lona-brillante',
} as const satisfies Readonly<Record<TubeSceneProduct['materialId'], string>>;

function safeToken(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'sin-dato';
}

function mmToken(value: number): string {
  return Number.isInteger(value) ? String(value) : String(value).replace('.', '_');
}

export function buildPdfFileName(scene: PdfSceneV1): string {
  if (scene.product.kind === 'tube') {
    return [
      'diseno',
      safeToken(scene.product.presetCode),
      MATERIAL_FILE_TOKENS[scene.product.materialId],
      mmToken(scene.product.developmentEffectiveMm) + 'x' + mmToken(scene.product.heightMm) + 'mm',
    ].join('-') + '.pdf';
  }
  return [
    'sticker',
    safeToken(scene.product.sourceLabel),
    mmToken(scene.product.widthMm) + 'x' + mmToken(scene.product.heightMm) + 'mm',
  ].join('-') + '.pdf';
}
